import React, { Component } from "react";
import { withScriptjs, withGoogleMap, GoogleMap, Marker } from "react-google-maps";

// Injectee au build depuis .env.local (cf. .env pour la reference).
const GOOGLE_MAPS_API_KEY = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;

if (!GOOGLE_MAPS_API_KEY) {
  console.error(
    "REACT_APP_GOOGLE_MAPS_API_KEY est absente : la carte ne s'affichera pas. " +
      "Renseignez-la dans src/frontend/.env.local, puis relancez le build."
  );
}

const MyMapComponent = withScriptjs(withGoogleMap((props) =>
    <GoogleMap
    defaultZoom={16}
    defaultCenter={{ lat: 47.38476, lng: 0.67596 }}
  >
    {props.isMarkerShown && <Marker position={{ lat: 47.38438412129914, lng: 0.6761365983898324 }} />}
  </GoogleMap>
))

class SimpleMap extends Component {

  render() {
    const { center, zoom } = this.props;
      return (
      <div style={{ height: "40vh", width: "100%" }}>
        <MyMapComponent
            isMarkerShown
            googleMapURL={`https://maps.googleapis.com/maps/api/js?key=${GOOGLE_MAPS_API_KEY}&v=3.exp&libraries=geometry,drawing,places`}
            loadingElement={<div style={{ height: `100%` }} />}
            containerElement={<div style={{ height: `100%` }} />}
            mapElement={<div style={{ height: `100%` }} />}
        />
      </div>
    );
  }
}

export default SimpleMap;
